import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { CountiesComponent } from "../../counties.component";

import { UserAccountApi, CountyApi } from '../../../../../../theme/services/sdk';
import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'
import {error} from "util";

@Component({
  selector: 'county-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,CountyApi,BaToastNotificationService]
})
export class CountyForm{

  public form:FormGroup;
  public name:AbstractControl;
  public submitted:boolean = false;

  county:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected countyService:CountyApi, private route: ActivatedRoute, private router: Router,private toast: BaToastNotificationService, private data: CountiesComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])]
    });

    this.name = this.form.controls['name'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.data.county.subscribe(data=>this.county=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let co;

      if(this.county['id']){
        co = this.countyService.upsert({
          id: this.county['id'],
          name: self.name['value']
        })
      }else{
        co = this.countyService.create({
          name: self.name['value']
        })
      }

      co.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.county['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New user added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/counties/components/form/form.component.ts